<template>
  <header id="headerApp" class="site_header" :class="{ artisan: artisanTabOpen && subNavOpen }" @mouseenter="cancelCloseTimer" @mouseleave="handleMouseLeave">
    <nav class="header_bar">
      <div class="bound">
        <div class="site-logo">
          <a href="https://3-form.com">
            <svg width="44px" height="15px" viewBox="0 0 80 20" version="1.1" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink">
              <title>3form</title>
              <path id="three-form-logo"
                d="M9.26625,4.2525 C6.825,4.2525 5.27625,5.7225 4.9875,8.11125 L-5.68434189e-14,8.11125 C0.2625,3.49125 3.59625,0.07875 9.37125,0.07875 C14.91,0.07875 18.19125,3.01875 18.19125,6.95625 C18.19125,9.84375 16.51125,11.62875 13.99125,12.495 C16.93125,13.15125 18.92625,15.225 18.92625,18.50625 C18.92625,18.9 18.87375,19.2675 18.76875,19.635 L13.04625,19.635 C13.15125,19.2675 13.20375,18.8475 13.20375,18.4275 C13.20375,16.065 11.865,14.88375 9.05625,14.88375 L6.93,14.88375 L6.93,10.73625 L8.89875,10.73625 C11.6025,10.73625 12.83625,9.58125 12.83625,7.48125 C12.83625,5.59125 11.62875,4.2525 9.26625,4.2525 Z M22.3125,19.635 L22.3125,9.10875 L20.58,9.10875 L20.58,5.90625 L22.3125,5.90625 L22.3125,5.04 C22.3125,1.6275 24.43875,-1.59872116e-14 27.69375,-1.59872116e-14 C28.56,-1.59872116e-14 29.21625,0.13125 29.84625,0.28875 L29.84625,3.7275 C29.505,3.6225 29.085,3.54375 28.56,3.54375 C27.4575,3.54375 26.985,4.1475 26.985,5.04 L26.985,5.90625 L29.7675,5.90625 L29.7675,9.10875 L26.985,9.10875 L26.985,19.635 L22.3125,19.635 Z M37.77375,19.95 C33.5475,19.95 30.26625,17.3775 30.26625,12.94125 L30.26625,12.73125 C30.26625,8.32125 33.5475,5.53875 37.8,5.53875 C42.02625,5.53875 45.28125,8.2425 45.28125,12.6 L45.28125,12.81 C45.28125,17.2725 42,19.95 37.77375,19.95 Z M37.8,16.45875 C39.55875,16.45875 40.50375,15.14625 40.50375,12.8625 L40.50375,12.6525 C40.50375,10.3425 39.585,9.05625 37.8,9.05625 C36.04125,9.05625 35.07,10.29 35.07,12.6 L35.07,12.81 C35.07,15.1725 35.98875,16.45875 37.8,16.45875 Z M46.9875,19.635 L46.9875,5.90625 L51.68625,5.90625 L51.68625,8.74125 C52.5525,6.69375 53.99625,5.80125 56.1225,5.8275 L56.1225,10.21125 C53.26125,10.1325 51.68625,11.025 51.68625,13.23 L51.68625,19.635 L46.9875,19.635 Z M57.9075,19.635 L57.9075,5.90625 L62.60625,5.90625 L62.60625,8.00625 C63.34125,6.69375 64.785,5.53875 66.91125,5.53875 C68.69625,5.53875 69.95625,6.32625 70.6125,7.8225 C71.79375,6.22125 73.42125,5.53875 75.15375,5.53875 C77.7525,5.53875 79.6425,7.21875 79.6425,10.6575 L79.6425,19.635 L74.94375,19.635 L74.94375,11.445 C74.94375,10.05375 74.26125,9.37125 73.185,9.37125 C71.925,9.37125 71.085,10.185 71.085,11.68125 L71.085,19.635 L66.465,19.635 L66.465,11.445 C66.465,10.05375 65.7825,9.37125 64.70625,9.37125 C63.44625,9.37125 62.60625,10.185 62.60625,11.68125 L62.60625,19.635 L57.9075,19.635 Z">
              </path>
            </svg>
          </a>
        </div>
        <div class="subnav-actions">
          <div class="subnav-actions">
            <a v-if="currentUser && showCustomerPortal" href="/my-dashboard" class="account_access">
              My Dashboard
            </a>
            <a v-if="isSalesStaff" href="/sales-web-portal" class="account_access">
              Sales Portal
            </a>
            <a v-if="currentUser" :href="logoutUrl" class="account_access">
              Log Out
            </a>
            <a v-else href="/signin" class="account_access">
              Sign In
            </a>
          </div>
          <clipboard />
        </div>
      </div>
    </nav>
    <div class="bound">
      <div class="main_header">
        <div class="site_logo">
          <a href="/" class="site-logo-container" :class="{ white: artisanTabOpen }"></a>
        </div>
        <div class="nav-actions">
          <div class="menu" :class="{ 'mobile-search': searchOpen, mobile: isMobile }">
            <button
              type="button"
              @click="handleNavClose"
              class="close_menu_actions logo"
            ></button>
            <div class="search-bar-wrapper">
              <button
                type="button"
                @click="handleMobileNavBackClick"
                :class="{ 'close_menu_actions back subnav-open': subNavOpen, 'close_menu_actions open_search': searchOpen, 'back-arrow-hidden': !subNavOpen }"
              ></button>
              <search-bar
                v-if="searchOpen"
                @searchResults="setSearchResults"
                @clearSearch="resetSearchResults"
              />
            </div>
            <div class="close_menu_btn_wrapper">
              <button type="button" class="close_menu"></button>
            </div>
          </div>

          <!-- Site Navigation -->
          <nav class="site_nav">
            <div class="main-nav">
              <ul v-if="!searchOpen || !isMobile">
                <li
                  v-if="!subNavOpen || (subNavOpen && !isMobile)"
                  v-for="item in navItems"
                  :key="item.uri"
                  class="top-nav"
                  @click="toggleSubnav"
                  @mouseenter="handleNavbarMouseEnter(item)"
                >
                  <span
                    :data-uri="item.uri"
                    :data-selected="currentTab === item.uri.slice(1)"
                    :class="{ selected: currentTab === item.uri.slice(1) }"
                  >
                    {{ item.name }}
                  </span>
                </li>
                <li
                  v-if="subNavOpen && isMobile"
                  v-for="link in currentTabSubnavLinks"
                  :key="link.uri"
                >
                  <a :href="link.uri || link.url">
                    <span>
                      {{ link.name }}
                    </span>
                  </a>
                </li>
              </ul>
              <div v-else-if="isMobile" class="mobile-search">
                <p>{{searchResultsHeader}}</p>
                <ul>
                  <li v-for="result in mobileSearchResults">
                    <a class="search-result-link" :href="result.uri || result.url">
                      {{ result.title }}
                    </a>
                  </li>
                  <li v-if="mobileSearchResults.length === 0">
                    <em class="search-result-link">no results.</em>
                  </li>
                </ul>
              </div>

              <div v-if="subNavOpen && isMobile && tertiaryMobileNavVisible" class="tertiary-mobile-nav">
                <template v-if="currentTab === 'products' || currentTab === 'resources'">
                  <h4> {{ currentTab === 'products' ? 'Product Families' : 'By Family' }} </h4>

                  <li v-for="link in productsByFamily.subnav">
                    <a :href="link.url || link.uri">
                      <span>
                        {{ link.name }}
                      </span>
                    </a>
                  </li>
                </template>
              </div>
            </div>

            <!-- Mobile User Navigation -->
            <div v-if="!subNavOpen" class="user_nav">
              <a v-if="currentUser && showCustomerPortal" href="/my-dashboard">
                My Dashboard
              </a>
              <a v-if="isSalesStaff" href="/sales-web-portal">
                Sales Portal
              </a>
              <a v-if="currentUser" :href="logoutUrl">
                Sign Out
              </a>
              <a v-else href="/signin">
                Sign In
              </a>
            </div>
          </nav>

          <!-- Product Sub-Navigation -->
          <div class="product-subnav-wrapper">
            <div class="product-subnav" :class="{ 'is-open': subNavOpen }">
              <ul class="product-subnav-list">
                <li
                  v-for="link in parsedNavItems"
                  class="product-subnav-list-item"
                  :class="{ selected: currentTab === link.uri.slice(1) }"
                >
                  <template v-if="currentTab === link.uri.slice(1)">
                    <ul class="product-subnav-list-item-tab" :class="{ 'border-right': currentTab === 'products' }">
                      <li
                        v-for="link in currentTabSubnavLinks"
                        @mouseenter="showNavbarImageOnHover(link)"
                      >
                        <a :href="link.url || link.uri">
                          <span :class="{ selected: currentProductSubCategory(link.uri) }">
                            {{ link.name }}
                          </span>
                        </a>
                      </li>
                    </ul>
                    <div v-if="currentTab === 'products'" class="product-subnav-image-container">
                      <img
                        v-if="primaryNavbarImage"
                        :alt="primaryNavbarImage.alt"
                        :src="primaryNavbarImage.src"
                        :sizes="primaryNavbarImage.sizes"
                        :srcset="primaryNavbarImage.srcset"
                        class="product-subnav-primary-image"
                      />
                      <img
                        v-else-if="parsedImageData"
                        v-for="image in parsedImageData"
                        :key="image.src"
                        :alt="image.alt"
                        :src="image.src"
                        :sizes="image.sizes"
                        :srcset="image.srcset"
                        class="product-subnav-image"
                      />
                    </div>
                  </template>
                  <template v-else>
                    <span class="product-subnav-list-item-header">
                      {{ link.name }}
                    </span>
                  </template>
                </li>
              </ul>
            </div>
          </div>

          <div
            v-if="!subNavOpen && currentCategory !== '' && !isMobile"
            class="product-display-toggle-container bound header-middle-border-active"
          >
            <div class="product-display-toggle">
              <a @click="currentCategory = 'type'">
                <span :class="{ selected: currentCategory === 'type' }">
                  Type
                </span>
              </a>
              <b class="toggle-slash"> / </b>
              <a @click="currentCategory = 'family'">
                <span :class="{ selected: currentCategory === 'family' }">
                  Family
                </span>
              </a>
            </div>
            <ul class="product-display-nav">
              <li
                v-if="link.uri !== '/products'"
                v-for="link in currentProducts.subnav"
              >
                <a :href="link.url || link.uri">
                  <span :class="{ selected: currentProductSubCategory(link.uri) }">
                    {{ link.name }}
                  </span>
                </a>
              </li>
            </ul>
            <a :href="currentCategory === 'family' ? '/products/family' : '/products/type'" class="see-all">
              <span>See All</span>
            </a>
          </div>
          <div
            v-if="!isMobile && subNavOpen && productDisplayToggleOpen"
            class="product-display-toggle-container bound header-middle-border-active"
          >
            <div class="product-display-toggle">
              <a :href="currentTab === 'resources' ? '/resources#downloads' : (productsByFamily.url || productsByFamily.uri)">
                <span :class="{ selected: currentCategory === 'family' }">
                  Product Families
                </span>
              </a>
            </div>
            <ul v-if="resourcesTertiaryNavLinks && currentTab === 'resources'" class="product-display-nav">
              <li v-for="link in resourcesTertiaryNavLinks" :key="link.id">
                <a :href="link.url || link.uri" @mouseenter="showNavbarImageOnHover(link)">
                  <span :class="{ selected: currentProductSubCategory(link.uri) }">
                    {{ link.name }}
                  </span>
                </a>
              </li>
            </ul>
            <ul v-else-if="productsByFamily && productsByFamily.subnav" class="product-display-nav">
              <li v-for="link in productsByFamily.subnav" :key="link.id">
                <a :href="link.url || link.uri" @mouseenter="showNavbarImageOnHover(link)">
                  <span :class="{ selected: currentProductSubCategory(link.uri) }">
                    {{ link.name }}
                  </span>
                </a>
              </li>
            </ul>
          </div>
          <div
            v-else-if="subNavOpen && (currentTab === 'artisan' || currentTab === 'inspiration' || currentTab === 'about-us')"
            class="product-display-toggle-container bound no-top-border"
          >
            <!-- NOTE: intentionally empty for simple bottom border -->
          </div>
        </div>

        <!-- Secondary Actions: Search Icon -->
        <span class="nav-secondary-actions">
          <a href="/search" class="svg-container search-icon">
            <svg class="svg-icon" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="14.37 4.8 995.85 1015.23">
              <path
                d="M1003.2 979.2L808 784c80-83.2 129.6-195.2 129.6-318.4C937.6 211.2 731.2 4.8 476.8 4.8S14.4 211.2 14.4 465.6s206.4 460.8 460.8 460.8c113.6 0 217.6-41.6 297.6-108.8l195.2 195.2c9.6 9.6 25.6 9.6 33.6 0 11.2-9.6 11.2-24 1.6-33.6zM62.4 465.6c0-227.2 185.6-412.8 412.8-412.8s412.8 185.6 412.8 412.8S704 878.4 475.2 878.4 62.4 692.8 62.4 465.6z" />
            </svg>
          </a>
        </span>

        <!-- mobile -->
        <div class="menu">
          <a href="/" class="site-logo-link"></a>
          <div class="right">
            <a @click="searchOpen = true" class="open_search"></a>
            <clipboard />
            <button @click="handleMenuOpen" type="button" class="open_menu"></button>
          </div>
        </div>
      </div>
      <div
        v-if="onProductCategoryIndexPage && isMobile && !mobileMainNavOpen && !searchOpen"
        class="product-display-toggle-container bound"
      >
        <div class="product-display-toggle">
          <div class="toggle-wrapper">
            <a @click="currentCategory = 'type'">
              <span :class="{ selected: currentCategory === 'type' }">
                Type
              </span>
            </a>
            <b class="toggle-slash"> / </b>
            <a @click="currentCategory = 'family'">
              <span :class="{ selected: currentCategory === 'family' }">
                Family
              </span>
            </a>
          </div>
        </div>
        <ul class="product-display-nav">
          <li
            v-if="link.uri !== '/products'"
            v-for="link in currentProducts.subnav"
          >
            <a :href="link.url || link.uri">
              <span :class="{ selected: currentProductSubCategory(link.uri) }">
                {{ link.name }}
              </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </header>
</template>


<script>
import clipboard from "./configurator/Clipboard.vue";
import searchBar from "./SearchBar.vue";

export default {
  components: {
    'clipboard': clipboard,
    'search-bar': searchBar,
  },
  props: [
    "navItems",
    "logoutUrl",
    "currentUser",
    "productsByType",
    "popularSearches",
    "productsByFamily",
    "resourcesTertiaryNavLinks",
  ],
  data() {
    return {
      tertiaryVisible: false,
      tertiaryMobileNavVisible: false,
      hoverState: null,
      timeouts: {},
      closeNavTimeout: null,
      window: {
        width: 0,
      },
      searchOpen: false,
      subNavOpen: false,
      parsedImageData: [],
      artisanTabOpen: false,
      primaryNavbarImage: null,
      mobileMainNavOpen: false,
      uriToImageMap: this.imageDataToMap(),
      currentTab: this.currentTabFromPath(),
      searchResultsHeader: 'Popular Searches',
      mobileSearchResults: this.popularSearches,
      currentCategory: this.parseCurrentCategory(),
    };
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    document.addEventListener('click', this.handleNavClose);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('click', this.handleNavClose);
    this.cancelCloseTimer();
  },
  computed: {
    isMobile() {
      return this.window.width < 992;
    },
    productDisplayToggleOpen() {
      return this.currentTab === 'products' || this.currentTab === 'resources';
    },
    parsedNavItems() {
      return this.navItems ? this.navItems : [];
    },
    isSalesStaff() {
      return this.currentUser && window.isSalesStaff;
    },
    showCustomerPortal() {
      return window.showCustomerPortal ? JSON.parse(window.showCustomerPortal) : false;
    },
    currentTabSubnavLinks() {
      if (this.currentTab === "products") {
        return this.productsByType.subnav;
      } else {
        const item = this.navItems.find(
          (item) => item.uri.slice(1) === this.currentTab
        );
        if (item && item.subnav) {
          return item.subnav;
        }
      }
      return [];
    },
    showProductToggle() {
      return ["products", "artisan"].includes(this.currentTab);
    },
    currentProducts() {
      switch (this.currentCategory) {
        case "type":
          return this.productsByType;
        case "family":
          return this.productsByFamily;
        default:
          return { subnav: [] };
      }
    },
    onProductCategoryIndexPage() {
      const isTypeIndex = this.$route.path.includes('products/type') || this.$route.path === '/products';
      const isFamilyIndex = this.$route.path.includes('products/family') || this.$route.path.includes('products/families');
      return isTypeIndex || isFamilyIndex;
    },
  },
  methods: {
    handleMenuOpen() {
      this.searchOpen = false;
      this.mobileMainNavOpen = true;
    },
    handleMobileNavBackClick() {
      this.subNavOpen = false;
      this.artisanTabOpen = false;
      this.currentTab = "";
    },
    setSearchResults(results) {
      this.mobileSearchResults = results.data;
      this.searchResultsHeader = "Results";
    },
    resetSearchResults() {
      this.searchResultsHeader = 'Popular Searches';
      this.mobileSearchResults = this.popularSearches;
    },
    setHover(menuId) {
      if (this.isMobile) return;
      if (this.tertiaryVisible) {
        this.timeouts[menuId] = setTimeout(() => {
          this.hoverState = menuId;
        }, 300);
        this.checkTime(this.timeouts[menuId]);
      } else {
        this.hoverState = menuId;
      }
    },
    checkHover(menuId) {
      return this.window.width >= 992 && this.hoverState === menuId;
    },
    checkTime(menuId) {
      if (this.isMobile) return;
      clearTimeout(this.timeouts[menuId]);
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.subNavOpen = false;
      this.artisanTabOpen = false;
    },
    startCloseTimer() {
      if (this.isMobile) return;

      // Clear any existing timeout
      this.cancelCloseTimer();

      // Set a new timeout to close the nav after a delay
      this.closeNavTimeout = setTimeout(() => {
        if (this.subNavOpen) {
          this.subNavOpen = false;
          this.artisanTabOpen = false;
        }
      }, 500);
    },
    handleMouseLeave(event) {
      if (this.isMobile) return;

      // Start the close timer, but we'll check for buffer in MouseMove
      this.startCloseTimer();
    },
    cancelCloseTimer() {
      if (this.closeNavTimeout) {
        clearTimeout(this.closeNavTimeout);
        this.closeNavTimeout = null;
      }
    },
    reset() {
      this.hoverState = null;
      this.tertiaryVisible = false;
      this.timeouts = {};
    },
    handleNavClose({ target }) {
      const siteHeader = document.getElementById('headerApp');

      if (this.isMobile && target.classList.contains('close_menu')) {
        this.mobileMainNavOpen = false;
        this.subNavOpen = false;
        this.artisanTabOpen = false;

        /* close the subnav on `mouseleave` */
      } else if (!this.isMobile && !siteHeader.contains(target) && this.subNavOpen == true) {
        this.subNavOpen = false;
        this.artisanTabOpen = false;
      }
    },
    imageDataToMap() {
      const allSubNavs = this.productsByType.subnav.concat(this.productsByFamily.subnav);

      const allParsedSubnavImages = allSubNavs.map((link) => {
        const parsedImages = this.parseImageData(link.images);
        link.images = parsedImages;
        return link;
      });

      return allParsedSubnavImages.reduce((acc, link) => {
        acc[link.uri] = link.images;
        return acc;
      }, {});
    },
    parseImageData(imageData) {
      if (!imageData && parseCurrentCategory() === 'type' && this.productsByType.imageData) {
        return [this.productsByType.imageData.map((image) => JSON.parse(image))];
      } else if (!imageData && parseCurrentCategory() === 'family' && this.productsByFamily.imageData) {
        return [this.productsByFamily.imageData.map((image) => JSON.parse(image))];
      }

      if (imageData && imageData.length > 0) {
        if (imageData.length === 1) {
          const primaryNavbarImage = JSON.parse(imageData[0]);
          return [primaryNavbarImage];
        }

        return imageData.map((image) => JSON.parse(image));
      }
      return [];
    },
    currentTabFromPath() {
      const pathArr = this.$route ? this.$route.path.split("/") : [];

      if (pathArr.length > 1 && pathArr[1] === "products") {
        return "products";
      }

      return pathArr.length > 1 ? pathArr[1] : "";
    },
    parseCurrentCategory() {
      const path = this.$route ? this.$route.path : "";

      if (path.includes("/family") || path.includes("/families")) {
        return "family";
      } else if (path.includes("/type") || path.includes("/types") || path === "/products") {
        return "type";
      }
      return "";
    },
    currentProductSubCategory(uri) {
      if (this.$route) {
        if (this.$route.path === '/products') {
          return uri === '/products';
        } else if (this.$route.path.includes('/products')) {
          return uri !== '/products' && this.$route.path.includes(uri);
        } else if (this.$route.path === '/blog') {
          return uri === '/blog';
        } else if (this.$route.path.includes('/blog')) {
          return uri !== '/blog' && this.$route.path.includes(uri);
        }
      }
      return false;
    },
    showNavbarImageOnHover(link) {
      if (this.isMobile) return;
      const images = this.uriToImageMap[link.uri];

      if (images && images.length > 0) {
        if (images.length === 1) {
          this.primaryNavbarImage = images[0];
          this.parsedImageData = null;
        } else {
          this.parsedImageData = images;
          this.primaryNavbarImage = null;
        }
      } else {
        this.primaryNavbarImage = null;
        this.parsedImageData = null;
      }
    },
    handleNavbarMouseEnter(link) {
      if (this.isMobile) return;

      const uri = link.uri;
      this.subNavOpen = true;
      this.currentTab = uri.slice(1);
      this.artisanTabOpen = (link.uri === '/artisan');

      this.showNavbarImageOnHover(link);
    },
    toggleSubnav(event) {
      event.stopPropagation();
      const target = event.target;
      this.artisanTabOpen = (target.dataset.uri === '/artisan');

      if (target.dataset.uri) {
        this.currentTab = target.dataset.uri.slice(1);

        /* mobile toggle */
        if (this.isMobile) {
          this.subNavOpen = true;

          if (target.dataset.uri === '/products' || target.dataset.uri === '/resources') {
            this.tertiaryMobileNavVisible = true;
          }

          /* desktop toggle */
        } else {
          if (target.dataset.selected) {
            this.subNavOpen = !this.subNavOpen;
          } else {
            this.subNavOpen = true;
          }
        }
      }
    },
  },
};
</script>
